package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.VisibilityW500Rounded: ImageVector
    get() {
        if (_visibilityW500Rounded != null) {
            return _visibilityW500Rounded!!
        }
        _visibilityW500Rounded = Builder(name = "VisibilityW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(607.5f, 587.5f)
                quadTo(660.0f, 535.0f, 660.0f, 460.0f)
                reflectiveQuadToRelative(-52.5f, -127.5f)
                quadTo(555.0f, 280.0f, 480.0f, 280.0f)
                reflectiveQuadToRelative(-127.5f, 52.5f)
                quadTo(300.0f, 385.0f, 300.0f, 460.0f)
                reflectiveQuadToRelative(52.5f, 127.5f)
                quadTo(405.0f, 640.0f, 480.0f, 640.0f)
                reflectiveQuadToRelative(127.5f, -52.5f)
                close()
                moveTo(407.09f, 532.91f)
                quadToRelative(-30.07f, -30.06f, -30.07f, -72.91f)
                quadToRelative(0.0f, -42.85f, 30.07f, -72.91f)
                quadToRelative(30.06f, -30.07f, 72.91f, -30.07f)
                quadToRelative(42.85f, 0.0f, 72.91f, 30.07f)
                quadToRelative(30.07f, 30.06f, 30.07f, 72.91f)
                quadToRelative(0.0f, 42.85f, -30.07f, 72.91f)
                quadToRelative(-30.06f, 30.07f, -72.91f, 30.07f)
                quadToRelative(-42.85f, 0.0f, -72.91f, -30.07f)
                close()
                moveTo(232.63f, 694.93f)
                quadTo(120.7f, 622.46f, 56.22f, 503.02f)
                quadToRelative(-5.72f, -10.19f, -8.46f, -21.01f)
                quadToRelative(-2.74f, -10.81f, -2.74f, -22.01f)
                quadToRelative(0.0f, -11.2f, 2.74f, -22.01f)
                quadToRelative(2.74f, -10.82f, 8.46f, -21.01f)
                quadToRelative(64.48f, -119.44f, 176.41f, -191.91f)
                quadTo(344.57f, 152.59f, 480.0f, 152.59f)
                reflectiveQuadToRelative(247.37f, 72.48f)
                quadToRelative(111.93f, 72.47f, 176.41f, 191.91f)
                quadToRelative(5.72f, 10.19f, 8.46f, 21.01f)
                quadToRelative(2.74f, 10.81f, 2.74f, 22.01f)
                quadToRelative(0.0f, 11.2f, -2.74f, 22.01f)
                quadToRelative(-2.74f, 10.82f, -8.46f, 21.01f)
                quadToRelative(-64.48f, 119.44f, -176.41f, 191.91f)
                quadTo(615.43f, 767.41f, 480.0f, 767.41f)
                reflectiveQuadToRelative(-247.37f, -72.48f)
                close()
                moveTo(480.0f, 460.0f)
                close()
                moveTo(687.02f, 620.38f)
                quadTo(781.28f, 560.76f, 831.28f, 460.0f)
                quadToRelative(-50.0f, -100.76f, -144.26f, -160.38f)
                quadTo(592.76f, 240.0f, 480.0f, 240.0f)
                reflectiveQuadToRelative(-207.02f, 59.62f)
                quadTo(178.72f, 359.24f, 128.72f, 460.0f)
                quadToRelative(50.0f, 100.76f, 144.26f, 160.38f)
                quadTo(367.24f, 680.0f, 480.0f, 680.0f)
                reflectiveQuadToRelative(207.02f, -59.62f)
                close()
            }
        }
        .build()
        return _visibilityW500Rounded!!
    }

private var _visibilityW500Rounded: ImageVector? = null
